import React from "react";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

const AreaField = (props) => {
  const { t } = useTranslation();
  const { propertyType, countSetter, index } = props;
  const { count, id, name, translationKey } = propertyType;
  return (
    <Box
      className="property-feild"
      sx={{
        backgroundColor: `${
          count > 0 ? "color.magentaLight2" : "color.smokeWhite"
        }`,
        color: `${count > 0 ? "color.black" : "color.dimGrey"}`,
        padding: "5px 15px",
        borderRadius: "27px",
        fontWeight: "500",
        fontSize: "0.8rem",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        minWidth: "200px",
        width: "auto",
        ["@media (max-width:1200px)"]: {
          // eslint-disable-line no-useless-computed-key
          width: "290px",
        },

        ["@media (max-width:450px)"]: {
          // eslint-disable-line no-useless-computed-key
          margin: "1rem",
          minWidth: "auto",
        },
      }}
    >
      {t(translationKey)}
      <Stack
        className="counter"
        direction="row"
        sx={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <span
          className="span-el"
          style={{
            cursor: "pointer !important",
            padding: "0.2rem",
          }}
          onClick={() =>
            propertyType.count > 0 ? countSetter(id, "decrement", index) : null
          }
        >
          -
        </span>
        <span
          style={{
            padding: "5px",
            textAlign: "center",
            minWidth: "2rem",
            background: "white",
            margin: "0 0.2rem",
          }}
        >
          {count}
        </span>
        <span
          className="span-el"
          style={{
            cursor: "pointer !important",
            padding: "0.2rem",
          }}
          onClick={() => countSetter(id, "increment", index)}
        >
          +
        </span>
      </Stack>
    </Box>
  );
};

export default AreaField;
